import React from 'react'
import { Text, VStack } from '@chakra-ui/react'

export const AutoRedirectNotice = () => (
  <VStack gap={4} align="center">
    <Text fontSize="xs" fontWeight="400" color="label.primary" lineHeight="16px" textAlign="center" whiteSpace="pre-line">
      {`この画面は10秒で自動的にアプリに切り替わります。

すぐにアプリに移動したい場合、または、自動で移動しない場合は「アプリに戻る」ボタンのタップをお願いします。`}
    </Text>
  </VStack>
)
